import { render, staticRenderFns } from "./GroupNotesDialog.vue?vue&type=template&id=52c15d32&scoped=true&"
import script from "./GroupNotesDialog.ts?vue&type=script&lang=ts&"
export * from "./GroupNotesDialog.ts?vue&type=script&lang=ts&"
import style0 from "./GroupNotesDialog.scss?vue&type=style&index=0&id=52c15d32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c15d32",
  null
  
)

export default component.exports